/* Naysee Bundle: muestra 3ml gratis + 2º perfume con descuento. Sin dependencias. */
(function () {
  if (customElements.get('naysee-bundle')) return;

  const SEARCH_SECTION = 'naysee-bundle-search';
  const PROMO_PROP = 'Promoción';

  class NayseeBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.percent = Number(this.dataset.percent) || 0;
      this.eligible = this.dataset.eligible;
      this.productId = this.dataset.productId;
      this.cache = new Map();
      this.selectedGift = null;

      this.msg = this.querySelector('[data-nb-msg]');
      this.giftNote = this.querySelector('[data-nb-gift-note]');
      this.input = this.querySelector('[data-nb-input]');
      this.results = this.querySelector('[data-nb-results]');

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      if (this.input) this.input.addEventListener('input', this.onInput.bind(this));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }
    }

    disconnectedCallback() {
      // La sección se reubica una vez junto al botón de compra; solo limpiamos si de verdad salió de la página.
      setTimeout(() => {
        if (this.isConnected || !this.unsubscribe) return;
        this.unsubscribe();
        this.unsubscribe = null;
      });
    }

    /* ---------- helpers ---------- */

    mainForm() {
      return document.querySelector('.product__info-container product-form[data-section-id$="__main"]');
    }

    mainVariantId() {
      const input = this.mainForm() && this.mainForm().querySelector('[name="id"]');
      return input ? String(input.value) : null;
    }

    formatMoney(cents) {
      const fmt = this.dataset.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    discounted(cents) {
      return Math.round(cents * (1 - this.percent / 100));
    }

    say(text, isError) {
      if (!this.msg) return;
      this.msg.textContent = text || '';
      this.msg.hidden = !text;
      this.msg.classList.toggle('is-error', !!isError);
    }

    async getCart() {
      const res = await fetch(`${window.routes ? routes.cart_url : '/cart'}.js`, { headers: { Accept: 'application/json' } });
      return res.json();
    }

    giftCount(cart) {
      return cart.items
        .filter((i) => i.properties && i.properties._nb_gift === '1')
        .reduce((total, i) => total + i.quantity, 0);
    }

    giftLimitReached(cart) {
      return this.giftCount(cart) >= (Number(this.dataset.maxGifts) || 3);
    }

    showLimit() {
      if (!this.giftNote) return;
      this.giftNote.textContent = this.dataset.limitNote;
      this.giftNote.classList.add('is-on');
    }

    // Agrega las líneas y re-renderiza el carrito lateral. El descuento lo calcula la app "Bundle Naysee"
    // a partir de las propiedades ocultas _nb_gift / _nb_second / _nb_pct.
    async addItems(items) {
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
      if (drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else if (!drawer) {
        window.location = window.routes ? routes.cart_url : '/cart';
      }
      return data;
    }

    /* ---------- 1. muestra gratis ---------- */

    selectGift(btn) {
      const already = btn.getAttribute('aria-checked') === 'true';
      this.querySelectorAll('.nb__gift[aria-checked="true"]').forEach((b) => b.setAttribute('aria-checked', 'false'));
      this.selectedGift = already
        ? null
        : { id: btn.dataset.variant, name: btn.dataset.name, size: btn.dataset.size || this.dataset.giftSize };
      if (!already) btn.setAttribute('aria-checked', 'true');
      if (this.giftNote) {
        this.giftNote.textContent = this.selectedGift
          ? this.dataset.selectedNote.replace('[muestra]', this.selectedGift.name).replace('[tamaño]', this.selectedGift.size)
          : this.giftNote.dataset.default;
        this.giftNote.classList.toggle('is-on', !!this.selectedGift);
      }
      if (this.selectedGift) {
        this.getCart().then((cart) => {
          if (this.selectedGift && this.giftLimitReached(cart)) this.showLimit();
        });
      }
    }

    giftItem() {
      return { id: Number(this.selectedGift.id), quantity: 1, properties: { [PROMO_PROP]: `Muestra ${this.selectedGift.size} GRATIS`, _nb_gift: '1', _nb_max: String(this.dataset.maxGifts || 3) } };
    }

    // Después de que el botón normal "Agregar al carrito" termina, añadimos la muestra elegida.
    async onCartUpdate(event) {
      if (!this.selectedGift || this.busy) return;
      if (!event || event.source !== 'product-form') return;
      if (String(event.productVariantId) !== this.mainVariantId()) return;
      this.busy = true;
      try {
        const cart = await this.getCart();
        if (this.giftLimitReached(cart)) this.showLimit();
        else await this.addItems([this.giftItem()]);
      } catch (e) {
        this.say(e.message, true);
      } finally {
        this.busy = false;
      }
    }

    /* ---------- 2. segundo perfume ---------- */

    onInput() {
      clearTimeout(this.timer);
      const q = this.input.value.trim();
      if (q.length < 2) {
        this.results.hidden = true;
        this.results.innerHTML = '';
        return;
      }
      this.timer = setTimeout(() => this.search(q), 280);
    }

    async search(q) {
      const key = q.toLowerCase();
      let html = this.cache.get(key);
      if (html === undefined) {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const params = new URLSearchParams({
          q,
          type: 'product',
          'options[prefix]': 'last',
          'options[unavailable_products]': 'hide',
          section_id: SEARCH_SECTION,
        });
        try {
          const res = await fetch(`/search?${params}`, { signal: this.controller.signal });
          html = await res.text();
          this.cache.set(key, html);
        } catch (e) {
          if (e.name !== 'AbortError') this.say('No se pudo buscar. Intenta de nuevo.', true);
          return;
        }
      }
      if (this.input.value.trim().toLowerCase() !== key) return;
      this.renderResults(html);
    }

    renderResults(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const label = this.dataset.addLabel;
      const items = [...doc.querySelectorAll('.nbs-item')]
        .filter((el) => el.dataset.productId !== this.productId)
        .filter((el) => !this.eligible || el.dataset.cols.indexOf(`,${this.eligible},`) !== -1)
        .slice(0, 6);

      this.results.innerHTML = '';
      if (!items.length) {
        const p = document.createElement('p');
        p.className = 'nbs-empty';
        p.textContent = this.dataset.empty;
        this.results.appendChild(p);
      }
      items.forEach((el) => {
        const now = el.querySelector('[data-nbs-now]');
        now.textContent = this.formatMoney(this.discounted(Number(now.dataset.cents)));
        el.querySelector('[data-nbs-add]').textContent = label;
        this.results.appendChild(document.importNode(el, true));
      });
      this.results.hidden = false;
    }

    onChange(e) {
      const select = e.target.closest('[data-nbs-variant]');
      if (!select) return;
      const item = select.closest('.nbs-item');
      const opt = select.selectedOptions[0];
      item.querySelector('[data-nbs-add]').dataset.variant = select.value;
      item.querySelector('[data-nbs-was]').textContent = opt.dataset.money;
      item.querySelector('[data-nbs-now]').textContent = this.formatMoney(this.discounted(Number(opt.dataset.cents)));
    }

    async addSecond(btn) {
      if (this.busy) return;
      this.busy = true;
      btn.disabled = true;
      this.say('');
      try {
        const cart = await this.getCart();
        const mainId = this.mainVariantId();
        const items = [];
        // El 1er perfume (el de esta página) entra si aún no está en el carrito.
        if (mainId && !cart.items.some((i) => String(i.variant_id) === mainId)) {
          items.push({ id: Number(mainId), quantity: 1 });
        }
        items.push({ id: Number(btn.dataset.variant), quantity: 1, properties: { [PROMO_PROP]: `2º perfume -${this.percent}%`, _nb_second: '1', _nb_pct: String(this.percent) } });
        if (this.selectedGift && !this.giftLimitReached(cart)) items.push(this.giftItem());
        await this.addItems(items);
        this.input.value = '';
        this.results.hidden = true;
      } catch (e) {
        this.say(e.message, true);
      } finally {
        this.busy = false;
        btn.disabled = false;
      }
    }

    toggleMore(btn) {
      const grid = this.querySelector('.nb__gifts');
      const label = btn.querySelector('[data-nb-more-label]');
      const open = btn.getAttribute('aria-expanded') !== 'true';
      if (!btn.dataset.more) btn.dataset.more = label.textContent;
      grid.classList.toggle('is-collapsed', !open);
      btn.setAttribute('aria-expanded', String(open));
      label.textContent = open ? btn.dataset.less : btn.dataset.more;
    }

    onClick(e) {
      const more = e.target.closest('[data-nb-more]');
      if (more) return this.toggleMore(more);
      const gift = e.target.closest('.nb__gift');
      if (gift) return this.selectGift(gift);
      const add = e.target.closest('[data-nbs-add]');
      if (add) this.addSecond(add);
    }
  }

  customElements.define('naysee-bundle', NayseeBundle);
})();
